/**
 * Hosted pay page lives on its own origin in production (`pay.aistyle.com`).
 * Locally PUBLIC_PAY_URL is this Vite app, so checkout just navigates in-place.
 */

export function payAppUrl(): string {
  return (import.meta.env.VITE_APP_URL as string | undefined)?.replace(/\/$/, "") ?? "";
}

export function payOrigin(): string {
  return (import.meta.env.VITE_PAY_ORIGIN as string | undefined)?.replace(/\/$/, "") ?? "";
}

/** True when this tab is the dedicated pay host, not the main AIStyle site. */
export function isPayHost(): boolean {
  const host = window.location.hostname;
  if (host === "pay.aistyle.com" || host.startsWith("pay.")) return true;
  const configured = payOrigin();
  if (!configured) return false;
  try {
    return new URL(configured).host === window.location.host;
  } catch {
    return false;
  }
}

/** Logo / "go home" target. On the pay host this is the main site. */
export function appHomeUrl(): string {
  if (!isPayHost()) return "/";
  return payAppUrl() || "#top";
}

/** Open `{PUBLIC_PAY_URL}/pay/{id}` — same origin navigates, otherwise a full load. */
export function goToPayPage(
  payUrl: string,
  navigate: (to: string) => void
): void {
  const url = new URL(payUrl, window.location.origin);
  if (url.origin === window.location.origin) {
    navigate(`${url.pathname}${url.search}${url.hash}`);
    return;
  }
  window.location.assign(url.href);
}
